import type { ReactNode } from 'react';

export { normalizeArea, byArea, areaColor } from './utils/area-color';

export function slugify(value: string): string {
  return value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}

export function Section({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <div className="space-y-2">
      <h2 className="text-(--color-text-secondary) text-xs font-semibold uppercase tracking-widest">
        {title}
      </h2>
      {children}
    </div>
  );
}
